import { IRestaurantOrder } from 'models';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const RESTAURANT_ORDERS_URL = `${API_BASE_URL}/api/restaurant-orders/`;

interface ICreateRestaurantOrderItem {
  product: number;
  quantity: number;
}

interface ICreateRestaurantOrderPayload {
  restaurantName?: string;
  phoneNumber?: string;
  note?: string;
  accessToken?: string;
  items: ICreateRestaurantOrderItem[];
}

export const createRestaurantOrder = async ({
  restaurantName,
  phoneNumber = '',
  note = '',
  accessToken,
  items,
}: ICreateRestaurantOrderPayload) => {
  const response = await fetch(RESTAURANT_ORDERS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: JSON.stringify({
      ...(restaurantName ? { restaurant_name: restaurantName } : {}),
      ...(phoneNumber ? { phone: phoneNumber } : {}),
      note,
      items,
    }),
  });

  if (!response.ok) {
    throw new Error('Could not create restaurant order.');
  }

  return response.json();
};

export const getRestaurantOrders = async (accessToken: string) => {
  const response = await fetch(RESTAURANT_ORDERS_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error('Could not load restaurant orders.');
  }

  return response.json() as Promise<IRestaurantOrder[]>;
};

export type { ICreateRestaurantOrderPayload };
